require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicinenet-diagnosis.json") })
        }
      }, "path---article-medicinenet-diagnosis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicinenet-diagnosis!./.cache/json/article-medicinenet-diagnosis.json
// module id = 356
// module chunks = 231608221292675